/**
 * cocosutra-card-hover.js
 *
 * Press-and-hold image peek for product cards on touch devices.
 *
 * Desktop hover is pure CSS (see cocosutra-global.css). Touch devices have no
 * hover state, so this holds the second image visible while the finger is down
 * and reverts on release. A normal tap never triggers it — the peek only starts
 * after HOLD_DELAY, so tapping through to the PDP is completely unaffected.
 *
 * Listeners are delegated on document, so cards inserted later by sliders or
 * AJAX collection filtering are covered without re-binding.
 */
(function () {
  'use strict';

  var PEEK_CLASS = 'cc-peek';
  var HOLD_DELAY = 120; // ms before the peek shows, so a quick tap just navigates
  var MOVE_TOLERANCE = 10; // px of finger travel that means "scrolling", not "peeking"
  var SELECTOR = '.cc-card13__media--has-hover, .hdt-card-product__media';

  var activeMedia = null;
  var holdTimer = null;
  var startX = 0;
  var startY = 0;

  function cancelPeek() {
    if (holdTimer) {
      clearTimeout(holdTimer);
      holdTimer = null;
    }
    if (activeMedia) {
      activeMedia.classList.remove(PEEK_CLASS);
      activeMedia = null;
    }
  }

  function hasHoverImage(media) {
    return (
      media.classList.contains('cc-card13__media--has-hover') ||
      media.querySelector('.hdt-card-product__media--hover') !== null
    );
  }

  function onTouchStart(event) {
    var touch = event.touches && event.touches[0];
    if (!touch) return;

    var target = event.target;
    if (!target || typeof target.closest !== 'function') return;

    var media = target.closest(SELECTOR);
    if (!media || !hasHoverImage(media)) return;

    cancelPeek();

    activeMedia = media;
    startX = touch.clientX;
    startY = touch.clientY;

    holdTimer = setTimeout(function () {
      holdTimer = null;
      if (activeMedia) activeMedia.classList.add(PEEK_CLASS);
    }, HOLD_DELAY);
  }

  function onTouchMove(event) {
    if (!activeMedia) return;

    var touch = event.touches && event.touches[0];
    if (!touch) return;

    if (
      Math.abs(touch.clientX - startX) > MOVE_TOLERANCE ||
      Math.abs(touch.clientY - startY) > MOVE_TOLERANCE
    ) {
      cancelPeek();
    }
  }

  document.addEventListener('touchstart', onTouchStart, { passive: true });
  document.addEventListener('touchmove', onTouchMove, { passive: true });
  document.addEventListener('touchend', cancelPeek, { passive: true });
  document.addEventListener('touchcancel', cancelPeek, { passive: true });
  window.addEventListener('scroll', cancelPeek, { passive: true });
  window.addEventListener('pagehide', cancelPeek);
})();
